import { httpClient } from './httpClient';

const base = '/api/malla';

// Obtener malla completa de un curso
export const obtenerMallaPorCurso = (cursoId) => 
  httpClient.get(`${base}/curso/${cursoId}`);

// Obtener un registro de malla específico
export const obtenerMallaItem = (id) => 
  httpClient.get(`${base}/${id}`);

// Agregar materia a curso
export const agregarMateriaCurso = (payload) => 
  httpClient.post(base, payload);

// Actualizar información de malla (docente, horas, orden, estado)
export const actualizarMalla = (id, payload) => 
  httpClient.put(`${base}/${id}`, payload);

// Reordenar materias en un curso
export const reordenarMaterias = (cursoId, ordenes) => 
  httpClient.post(`${base}/curso/${cursoId}/reordenar`, { ordenes });

// Asignar docente a una materia en malla
export const asignarDocente = (id, docenteId) =>
  httpClient.put(`${base}/${id}/docente`, { docente_id: docenteId });

// Reemplazar el set de docentes ADICIONALES calificados para esa materia
export const actualizarDocentesCalificados = (id, docenteIds) =>
  httpClient.put(`${base}/${id}/docentes-calificados`, { docente_ids: docenteIds });

// Alta/baja de un solo docente calificado (vista "por docente")
export const agregarDocenteCalificado = (id, docenteId) =>
  httpClient.post(`${base}/${id}/docentes-calificados/${docenteId}`);
export const quitarDocenteCalificado = (id, docenteId) =>
  httpClient.del(`${base}/${id}/docentes-calificados/${docenteId}`);

// Eliminar materia de curso
export const eliminarMateriaCurso = (id) => 
  httpClient.del(`${base}/${id}`);

// Obtener asignaciones de un docente
export const obtenerAsignacionesDocente = (docenteId) => 
  httpClient.get(`${base}/docente/${docenteId}/asignaciones`);

// Obtener materias sin docente en un curso
export const obtenerMateriasSinDocente = (cursoId) => 
  httpClient.get(`${base}/curso/${cursoId}/sin-docente`);

const mallaService = {
  obtenerMallaPorCurso,
  obtenerMallaItem,
  agregarMateriaCurso,
  actualizarMalla,
  reordenarMaterias,
  asignarDocente,
  actualizarDocentesCalificados,
  agregarDocenteCalificado,
  quitarDocenteCalificado,
  eliminarMateriaCurso,
  obtenerAsignacionesDocente,
  obtenerMateriasSinDocente,
};

export default mallaService;
